"use client";

import { useState, useEffect } from 'react';
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { TheContent, preContent } from "@/helpers/utils";

export default function NoticiasPage({ data }) {
  const [pageRoute, setPageRoute] = useState('/noticias');

  return (
    <main className="w-full flex flex-col items-center bg-white">

      <section className="relative w-full">
            <Image
                src="/assets/banner3.jpg"
                alt="Banner Notícias"
                width={1920}
                height={500}
                className="w-full h-[500px] object-cover"
                priority
            />
            <div className="absolute inset-0 bg-black/40 flex flex-col justify-center items-center">
                <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold">
                Insights e Notícias do Setor
                </h1>
                <p className="text-white text-lg sm:text-xl mt-4">
                Fique por dentro de tudo sobre o setor contábil
                </p>
            </div>
      </section>

      {/* SEÇÃO DE NOTÍCIAS */}
      <section className="w-full bg-white py-16 px-4">
        <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center text-center">
          <img
            src="/assets/logos1.png"
            alt="Logos"
            className="w-[200px] sm:w-[350px] md:w-[400px] mb-10"
          />

          { data.docs.length > 0 ? (
            <div className="w-full max-w-[1440px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center mb-12">
              {data.docs.map((item, key) => (
                <div
                  key={key}
                  className="w-[360px] sm:w-[380px] md:w-[400px] h-[600px] rounded-2xl overflow-visible shadow-lg transform transition-transform duration-300 hover:-translate-y-2 relative bg-transparent mb-10"
                >
                  {/* IMAGEM */}
                  <div className="bg-blue-700 h-[230px] rounded-t-2xl relative flex justify-center items-end">
                    <img
                      src={ item.contentImages1.mediaCdnUrl }
                      alt={ item.contentTitle }
                      className="w-[340px] sm:w-[360px] h-[270px] object-cover rounded-t-xl absolute bottom-[-20px] shadow-lg"
                    />
                  </div>

                  {/* CONTEÚDO */}
                  <div className="bg-[#ecf0f1] h-[360px] px-6 py-8 text-left rounded-b-2xl">
                    <h3 className="text-blue-700 text-[20px] font-semibold mb-2">
                      { item.contentTitle }
                    </h3>
                    <div className="w-[60px] h-[2px] bg-blue-700 mb-3"></div>
                    <p className="text-gray-800 text-[15px] leading-snug mb-5">
                      { preContent(item.contentEditor1) }
                    </p>
                    <Link
                      href={`/noticias/${ item.contentSlug }`}
                      className="text-blue-700 font-semibold text-[15px] hover:underline cursor-pointer"
                    >
                      Saiba mais →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-500 col-span-full">
              Nenhuma notícia encontrada.
            </p>
          )}


          {/* PAGINAÇÃO */}
          <div className="flex gap-4 justify-center">
            { data.hasPrevPage === true && (
              <a href={`${pageRoute}?pagina=${data.prevPage}`} title="Página Anterior" className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 transition">
                ← Anteriores
              </a>
            ) }

            { data.hasNextPage === true && (
              <a href={`${pageRoute}?pagina=${data.nextPage}`} title="Próxima Página" className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 transition">
                Próximas →
              </a>
            ) }
          </div>
        </div>
      </section>


    </main>
  );
}
